export default class CheckboxController {
	constructor($scope) {
		$scope.checkValue = false;
	}
}

CheckboxController.$inject = ["$scope"];


/** WEBPACK FOOTER **
 ** ./src/modules/demo/controllers/checkbox.js
 **/